import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  language: "en",
  isMobile: false,
  token: "",
  ssoToken: "",
  user: {},
  loader: false,
  apiError: "",
  tokenRefetch: 0,
  showSnakBar: false,
  snackMessage: "",
  snackVariant: "success"
};
const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    changeLanguage: (state, action) => {
      state.language = action.payload;
    },
    detectMedia: (state, action) => {
      state.isMobile = action.payload;
    },
    setAuthToken: (state, action) => {
      state.token = action.payload;
    },
    setSsoToken: (state, action) => {
      state.ssoToken = action.payload;
    },
    setLoggeInUser: (state, action) => {
      state.user = action.payload;
    },
    showLoader: (state, action) => {
      state.loader = action.payload;
    },
    setApiErrorStatus: (state, action) => {
      state.apiError = action.payload;
    },
    refetchToken: (state, action) => {
      state.tokenRefetch = action.payload
        ? action.payload
        : state.tokenRefetch + 1;
    },
    setSnackMessage: (state, action) => {
      state.showSnakBar = action.payload.open;
      state.snackMessage = action.payload.message;
      state.snackVariant = action.payload.variant;
    },
  },
});

export const {
  changeLanguage,
  detectMedia,
  setAuthToken,
  setSsoToken,
  setLoggeInUser,
  showLoader,
  setApiErrorStatus,
  refetchToken,
  setSnackMessage,
} = globalSlice.actions;

export default globalSlice.reducer;
